import { SCOPES } from './constants';

const formConfig = {
  scopeChoices: [
    {
      label: 'Customers',
      value: SCOPES.customers,
    },
    {
      label: 'Orders',
      value: SCOPES.orders,
    },
  ],
};

export default formConfig;
